import _ from 'underscore';

venueService.$inject = [
  '$q',
  'jsSdk.venue',
  'organizationService',
  'userPreferencesService'
];

export default function venueService($q, sdkVenueService, organizationService, userPreferencesService) {
  class VenueService {
    clear() {
      this._currentVenues = null;
      this._currentVenue = null;
    }

    _setCurrentVenues(venues) {
      if (!venues) throw new Error('venues is required');

      this._currentVenues = venues;
    }

    setCurrentVenue(venue) {
      if (!venue) throw new Error('venue is required');

      this._currentVenue = venue;
    }

    findById(id) {
      if (!id) throw new Error('VenueService - findById() - id is required');

      return this.getCurrentVenues()
        .then(venues => {
          return _.findWhere(venues, {
            id
          });
        });
    }

    getCurrentVenues() {
      const currentOrganization = organizationService.getCurrentOrganization();

      if (!currentOrganization) throw new Error('VenueService - getCurrentVenues() - currentOrganization is required');

      if (this._currentVenues) return $q.resolve(this._currentVenues);

      return sdkVenueService.listByOrganizationId(currentOrganization.id)
        .then(venues => {
          this._setCurrentVenues(venues);

          let defaultVenue = venues[0];

          // see if we can set the default venue from users preferences
          const defaultVenueId = userPreferencesService.getDefaultVenue();

          if (defaultVenueId) {
            const foundDefaultVenue = _.findWhere(this._currentVenues, {
              id: defaultVenueId
            });
            if (foundDefaultVenue) defaultVenue = foundDefaultVenue;
          }

          this.setCurrentVenue(defaultVenue);

          return venues;
        });
    }

    getCurrentVenue() {
      return this._currentVenue;
    }
  }

  return new VenueService();
}



// WEBPACK FOOTER //
// ./src/services/venueService.js